import { render } from "./WikiCard.vue?vue&type=template&id=1fb93fb8&scoped=true"
import script from "./WikiCard.vue?vue&type=script&lang=js"
export * from "./WikiCard.vue?vue&type=script&lang=js"

import "./WikiCard.vue?vue&type=style&index=0&id=1fb93fb8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb93fb8"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QIcon,QItemSection,QChip,QBtn,QInnerLoading});
